import { rootRoute } from './__root';
import { authLayoutRoute } from './layouts/auth-layout-route';
import { dashboardLayoutComponent } from './layouts/dashboard-layout-route';
import { loginRedirectRoute, loginRoute } from './auth/login-route';
import * as dashboardRoutes from './protected/dashboard-route';
import * as registerForm from './protected/register-form-route';
import * as profileRoutes from './protected/profile-route';
import * as paymentLinkRoutes from './protected/payment-link-route';
import * as InvoicesRoutes from './protected/invoices-route';
import * as EwalletRoutes from './protected/ewallet-route';
import * as CreditCardRoutes from './protected/credit-card-route';
import { transactionDetailRoute, transactionRoute } from './protected/transaction-route';
import {
  forgotPasswordRoute,
  registerMemberRoute,
  registerRoute,
  resendEmailRoute,
  resetPasswordRoute,
  verificationEmailRoute,
} from './unprotected-route/auth';
import { protectedRoute } from './protected/protected-route';
import { dashboardPlainLayoutRoute } from './layouts/dashboard-plain-layout-route';
import {
  addMerchantRoute,
  detailMerchantRoute,
  editMerchantRoute,
  merchantRoute,
} from './protected/merchant-route';
import { detailVirtualAccountRoute, virtualAccountRoute } from './protected/virtual-account-route';
import { detailQrisRoute, qrisRoute } from './protected/qris-route';
import {
  detailDisbursementRoute,
  disbursementRoute,
  detailBatchDisbursementRoute,
} from './protected/disbursement-route';
import { detailDirectDebitRoute, directDebitRoute } from './protected/direct-debit-route';
import {
  settlementReportDetailRoute,
  settlementReportRoute,
  settlementRoute,
  settlementSummaryRoute,
} from './protected/settlement-route';
import * as CashFlowRoutes from './protected/cash-flow-router';
import * as AccountGroupRoutes from './protected/account-group';
import * as AccountGroupCommissionRoutes from './protected/account-group-commission';
import * as downloadPortalRoutes from './protected/download-portal-route';

import { indexRoute } from '.';

export const routeTree = rootRoute.addChildren([
  indexRoute,
  authLayoutRoute.addChildren([
    loginRoute,
    loginRedirectRoute,
    registerRoute,
    resendEmailRoute,
    verificationEmailRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
    registerMemberRoute,
  ]),

  protectedRoute.addChildren([
    dashboardLayoutComponent.addChildren([
      ...Object.values(dashboardRoutes),
      ...Object.values(profileRoutes),
      ...Object.values(paymentLinkRoutes),
      ...Object.values(InvoicesRoutes),
      ...Object.values(CashFlowRoutes),
      ...Object.values(AccountGroupRoutes),
      ...Object.values(AccountGroupCommissionRoutes),
      ...Object.values(EwalletRoutes),
      ...Object.values(downloadPortalRoutes),
      ...Object.values(CreditCardRoutes),
      transactionRoute.addChildren([transactionDetailRoute]),
      merchantRoute.addChildren([detailMerchantRoute, editMerchantRoute, addMerchantRoute]),
      directDebitRoute.addChildren([detailDirectDebitRoute]),
      virtualAccountRoute.addChildren([detailVirtualAccountRoute]),
      qrisRoute.addChildren([detailQrisRoute]),
      disbursementRoute.addChildren([detailDisbursementRoute, detailBatchDisbursementRoute]),
      settlementRoute.addChildren([
        settlementReportRoute,
        settlementSummaryRoute,
        settlementReportDetailRoute,
      ]),
    ]),
    dashboardPlainLayoutRoute.addChildren([registerForm.registerFormEnterpriseFormRoute]),
  ]),
]);
